export default "__VITE_ASSET__BK_F7SzQ__"